import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'Components/forms/text-field/TextField';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import '../forms.styles.js';
import './TextInput.scss';
import { VITE_isFirefox } from 'Constants/appEnvConstants';

export const TextInput = ({
  asterikRequired,
  isRequiredText,
  name,
  label,
  disable,
  onChange,
  onKeyUp,
  type,
  placeholder,
  value,
  labelTooltip,
  error,
  onBlur,
  isRequired,
  hideErrorIcon,
  extraClass,
  width,
  hideLabel,
  isWidthFixRequired,
  removeFilterAction,
  showDynamicFilter,
  updatedId,
  extraStyle,
  extraClassLabel,
  filterErrorMsg,
  reportName,
  readOnly,
  min,
  max,
  maxLength,
}) => {

  let wrapperClass = 'field';
  const acquirerCode = JSON.parse(sessionStorage.getItem('state')).auth.user.acquirerCode;
  let inputClass =
    (VITE_isFirefox && type === 'number' && isWidthFixRequired ? 'field-input-firefox' : 'field-input') +
    ' field-input_' +
    acquirerCode;
  if (error) {
    wrapperClass += ' field-danger';
  }
  if (extraClass) {
    wrapperClass += ' global-selector-field';
    inputClass += ' global-selector-field-color';
  }

  if (name === 'global_merchants') {
    wrapperClass += ' global-selector-merchantField';
    inputClass += ' global-selector-field-color';
  }

  const allowedTypes = ['text', 'email', 'url', 'number', 'tel'];
  const foundType = allowedTypes.findIndex((kind) => kind === type);

  const inputType = foundType ? type : 'text';
  const labelContent = (
    <span className="">
      {extraStyle ? (
        <span style={extraStyle}>{label}</span>
      ) : extraClassLabel ? (
        <span className={extraClassLabel}>{label}</span>
      ) : (
        label
      )}
      {isRequired && asterikRequired && !isRequiredText && <span className="error-message">*</span>}
      {isRequired && isRequiredText && <span className="field__required">(required)</span>}
      {!error && labelTooltip}
      {reportName === 'MRE' && filterErrorMsg && (
        <span
          style={{
            color: '#f4364c',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '11px',
            marginLeft: '8px',
          }}
        >
          {filterErrorMsg}
        </span>
      )}
    </span>
  );

  return (
    <TextField
      fieldClass={wrapperClass}
      htmlFor={name}
      hideLabel={hideLabel}
      labelContent={labelContent}
      error={error}
      width={width}
      removeFilterAction={removeFilterAction}
      showDynamicFilter={showDynamicFilter}
      updatedId={updatedId}
    >
      <input
        type={inputType}
        name={name}
        id={name}
        className={!filterErrorMsg ? `${inputClass} ${extraClass}` : `${inputClass} ${extraClass} filterErrorMessage`}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e, isRequired)}
        onKeyUp={onKeyUp}
        onBlur={onBlur}
        aria-required={isRequired}
        width={width}
        disabled={disable}
        style={reportName === 'MRE' && disable ? { cursor: 'not-allowed' } : {}}
        maxLength={
          reportName === 'MRE' && name == 'mre_rule_name'
            ? '30'
            : reportName === 'MRE' && name == 'mre_description'
            ? '100'
            : (max || maxLength)
        }
        readOnly={readOnly}
        minlength={min}
      />
      {!!error && <span className="error-message"> {error}</span>}
    </TextField>
  );
};

TextInput.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  onBlur: PropTypes.func,
  isRequired: PropTypes.bool,
  labelTooltip: PropTypes.object,
  disable: PropTypes.bool,
  hideLabel: PropTypes.bool,
  isWidthFixRequired: PropTypes.bool,
  removeFilterAction: PropTypes.func,
  showDynamicFilter: PropTypes.bool,
  updatedId: PropTypes.string,
  maxLength: PropTypes.string,
  readOnly: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  maxLength: PropTypes.string,
};

TextInput.defaultProps = {
  type: 'text',
  placeholder: '',
  value: '',
  error: '',
  onBlur: null,
  isRequired: false,
  labelTooltip: null,
  hideErrorIcon: true,
  disable: false,
  hideLabel: false,
  isWidthFixRequired: false,
  removeFilterAction: () => {},
  showDynamicFilter: false,
  updatedId: '',
  isRequiredText: false,
  asterikRequired: true,
  extraClassLabel: '',
  maxLength: '',
  readOnly: false,
  min: '',
  max: '',
  maxLength: '',
};

export default TextInput;
